import { MediumModel } from "models/MediumModel";

export interface Color {
  name:
    | "black"
    | "blue"
    | "darkblue"
    | "darkgreen"
    | "lightgreen"
    | "green"
    | "orange"
    | "pink"
    | "purple"
    | "red"
    | "turquoise"
    | "yellow";
  hex: string;
}

/* Color - Grays */
export const COLOR_WHITE = "#fff";
export const COLOR_BLACK = "#040404";
export const COLOR_MEDIUM_GRAY = "#828282";
export const COLOR_LIGHT_GRAY = "#e4e4e4";

/* Color - Accents */
export const COLOR_BLUE = "#4369f2";
export const COLOR_GREEN = "#75e393";
export const COLOR_RED = "#e0534d";
export const COLOR_YELLOW = "#f3ee10";

/* Color - Variants */
export const COLOR_DARKBLUE = "#4047ff";
export const COLOR_DARKGREEN = "#007934";
export const COLOR_LIGHTGREEN = "#41e26d";
export const COLOR_ORANGE = "#ff973a";
export const COLOR_PINK = "#fa7fe6";
export const COLOR_PURPLE = "#bd94f0";
export const COLOR_TURQUOISE = "#6beaea";

/* Color - By Medium */
export const COLOR_DANCE = COLOR_PINK;
export const COLOR_DRAWING = COLOR_ORANGE;
export const COLOR_FILM_DANCE = COLOR_PINK;
export const COLOR_LITERATURE = COLOR_DARKBLUE;
export const COLOR_MUSIC = COLOR_TURQUOISE;
export const COLOR_PAINTING = COLOR_PURPLE;
export const COLOR_PHOTOGRAPHY = COLOR_LIGHTGREEN;
export const COLOR_SCULPTURE = COLOR_DARKGREEN;

/**
 * @param medium MediumModel to retrieve color for
 * @returns Color associated with the medium
 */
export function getColorForMedium(medium: MediumModel): Color {
  switch (medium.id) {
    // Film & Dance
    case "FD":
      return {
        name: "pink",
        hex: COLOR_PINK,
      };
    // Drawing
    case "DR":
      return {
        name: "orange",
        hex: COLOR_ORANGE,
      };
    // Literature
    case "LI":
      return {
        name: "darkblue",
        hex: COLOR_DARKBLUE,
      };
    // Music
    case "MU":
      return {
        name: "turquoise",
        hex: COLOR_TURQUOISE,
      };
    // Painting
    case "PA":
      return {
        name: "purple",
        hex: COLOR_PURPLE,
      };
    // Photography
    case "PH":
      return {
        name: "lightgreen",
        hex: COLOR_LIGHTGREEN,
      };
    // Sculpture
    case "SC":
      return {
        name: "darkgreen",
        hex: COLOR_DARKGREEN,
      };
    // Other
    case "OT":
    default:
      return {
        name: "lightgreen",
        hex: COLOR_LIGHTGREEN,
      };
  }
}
